const state = {
  list: {
    count: 0,
    data: []
  },
  requestForProposal: {}
}

export default state
